/**
 * printVersion
 */
export function printVersion(): void {
    const IS_PROD = import.meta.env.PROD;
    const color = IS_PROD ? 'green' : '#40a9ff';
    const style = `color:#fff;background-color:${color};border-radius:2px;`;
    print('当前版本', __PACKAGE_VERSION__, style);
}
/**
 * print
 */
function print(title: string, info: string | undefined, style: string): void {
    // eslint-disable-next-line no-console
    console.log(`%c ${title}: %c ${info ?? ''} `, style, '');
}
